"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.asLocalizedText = exports.ConfirmationDialog = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Button = require("@fluentui/react/lib/Button");

var _Dialog = require("@fluentui/react/lib/components/Dialog");

var React = _interopRequireWildcard(require("react"));

/**
 * Represents a simple ok/cancel dialog
 */
var ConfirmationDialog = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ConfirmationDialog, _React$Component);

  var _super = (0, _createSuper2.default)(ConfirmationDialog);

  function ConfirmationDialog() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, ConfirmationDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this._ok = function () {
      _this.props.ok(_this.props.okAction, _this.props.parameters);
    };

    _this._cancel = function () {
      _this.props.cancel(_this.props.cancelAction, _this.props.parameters);
    };

    return _this;
  }

  (0, _createClass2.default)(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          hidden = _this$props.hidden,
          title = _this$props.title,
          subText = _this$props.subText,
          okButtonText = _this$props.okButtonText,
          okButtonAriaLabelText = _this$props.okButtonAriaLabelText,
          cancelButtonText = _this$props.cancelButtonText,
          cancelButtonAriaLabelText = _this$props.cancelButtonAriaLabelText,
          showCloseButton = _this$props.showCloseButton;
      var okText = asLocalizedText(okButtonText, t) || t('Ok');
      var cancelText = asLocalizedText(cancelButtonText, t) || t('Cancel');
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, {
        hidden: !!hidden,
        modalProps: {
          isAlert: true
        },
        dialogContentProps: {
          title: asLocalizedText(title, t),
          subText: asLocalizedText(subText, t),
          closeButtonAriaLabel: cancelText,
          showCloseButton: showCloseButton === undefined ? true : showCloseButton
        },
        onDismiss: this._cancel,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.DialogFooter, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
            onClick: this._ok,
            text: okText,
            ariaLabel: asLocalizedText(okButtonAriaLabelText, t) || okText
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.DefaultButton, {
            onClick: this._cancel,
            text: cancelText,
            ariaLabel: asLocalizedText(cancelButtonAriaLabelText, t) || cancelText
          })]
        })
      });
    }
  }]);
  return ConfirmationDialog;
}(React.Component);

exports.ConfirmationDialog = ConfirmationDialog;

var asLocalizedText = function asLocalizedText(textOrLocalizedMessage, t) {
  if (textOrLocalizedMessage === undefined) {
    return '';
  }

  if (typeof textOrLocalizedMessage === 'string') {
    return textOrLocalizedMessage;
  }

  return t(textOrLocalizedMessage.key, textOrLocalizedMessage.options);
};

exports.asLocalizedText = asLocalizedText;